

const HIKE_BASE_URL = process.env.REACT_APP_HIKE_BASE_URL

export {HIKE_BASE_URL}